/*
* This file contain all reducers state
*/
import { combineReducers } from 'redux';
import _ from 'lodash';
import signUpReducer from './signup';
import login from './login';
import jobs from './jobs';
import manuals from './manuals';
import templates from './templates';
import company from './company';
import notifications from './notifications';
import subscriptionsReducer from './subscriptions';
import profile from './profile';
import systemReducer from './system';

const allreducers=combineReducers({
	signup: signUpReducer,
	login: login,
	jobs: jobs,
	notifications:notifications,
  templates: templates,
  manuals: manuals,
  company: company,
  subscription: subscriptionsReducer,
  profile: profile,
  system: systemReducer
});

export default allreducers;

export const getTemplateById = (state, templateId) => {
  if( !_.has(state, 'templates.items')) {
    return null;
  }
  return _.find(state.templates.items, { _id: templateId });
};

export const getJobById = (state, jobId) => {
  if( !_.has(state, 'jobs.items') ) {
    return null;
  }

  return _.find(state.jobs.items, { simpro_id: parseInt(jobId, 10) });
};


// WEBPACK FOOTER //
// ./src/Reducers/index.js